var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"text-left",attrs:{"type":"info","dense":"","rounded":"","text":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.$t('delivery.mode.estimatedTime', {hour: _vm.hour}))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }